export enum AddressEntityType {
    Region = 1,
    District,
    City,
    County,
    PostalCode,
    Street,
    House,
    Floor,
    Flat,
    Neighborhood = 11,
    PersonalNumber = 12,
}
export enum AddressEntryTypeId {
    Text = 1,
    Selection,
    Hidden,
    Hybrid,
    AllInOneSelection,
}
